var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_1637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1121 8.03349L17.6473 5.26302C17.5543 4.70575 17.7348 4.13755 18.134 3.73833L20.934 0.938331C21.3332 0.494049 22.1316 0.648487 22.3668 1.232L23.6246 4.37489L26.7691 5.58349C27.3488 5.86786 27.4582 6.61708 27.059 7.06552L24.259 9.86552C23.8598 10.2647 23.291 10.396 22.7387 10.3522L19.966 9.88739L14.8801 14.8804C14.4152 15.4382 13.584 15.4382 13.0699 14.8804C12.5613 14.4155 12.5613 13.5843 13.0699 13.0702L18.1121 8.03349Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.0375 11.6758L21.6016 11.9383C21.782 12.5945 21.875 13.2836 21.875 14C21.875 18.3477 18.3477 21.875 14 21.875C9.65234 21.875 6.125 18.3477 6.125 14C6.125 9.65234 9.65234 6.125 14 6.125C14.7164 6.125 15.4055 6.21797 16.0617 6.34922L16.3242 7.9625L14.618 9.66875C14.4156 9.64141 14.2078 9.57578 14 9.57578C11.5828 9.57578 9.625 11.5828 9.625 13.9508C9.625 16.4172 11.5828 18.375 14 18.375C16.4172 18.375 18.375 16.4172 18.375 13.9508C18.375 13.7922 18.3586 13.5844 18.3313 13.382L20.0375 11.6758ZM27.218 9.37891C27.6773 10.7789 28 12.3812 28 14C28 21.7328 21.7328 28 14 28C6.26719 28 0 21.7328 0 14C0 6.26719 6.26719 0 14 0C15.6188 0 17.1719 0.27475 18.6211 0.780391L15.7555 3.64602C15.1813 3.54977 14.5961 3.5 14 3.5C8.15391 3.5 3.5 8.15391 3.5 14C3.5 19.7969 8.15391 24.5 14 24.5C19.7969 24.5 24.5 19.7969 24.5 14C24.5 13.4039 24.4508 12.8187 24.3523 12.2445L27.218 9.37891Z",
    fill: "#0066FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_1637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.2282f17e6e204c8b83d2de212ce6dc9b.svg";
export { ForwardRef as ReactComponent };